import * as MyKeysApi from './index';
import {
  CriteriaListDto,
  MyKeysPromise,
  DeviceInfoRequest,
  PageRequest,
  DatesRequest,
  SetReadRightsRequest,
} from '../../../interfaces';
import {
  buildCriteraList,
  getDevicesFromSNFilter,
  getDevicesFromSNLabelFilter,
} from './searchCriteria';
import * as Devices from '../../../modules/devices';
import { CustomerInfo } from '../../../models';
import { PageSize } from '../../../modules/dialogs/deviceInfo';
import { getDevicesLabelsFilter, getDevicesSNFilter } from '../../../modules/devices';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

export const searchPage = (
  pageIdx: number,
  deviceState: Devices.State
): Promise<any> => {
  const requestBatch = deviceState.data.pageSize;
  const criteria = buildCriteraList(deviceState.filters, deviceState.sort);
  const devices: Devices.PKey[] = getDevicesFromSNFilter(
    String(deviceState.filters.serialNumber)
  );
  const deviceLabels: string[] = getDevicesFromSNLabelFilter(deviceState.filters.snLabel);
  const body = {
    criteria,
    devices,
    deviceLabels,
    pageIndex: pageIdx - 1,
    pageSize: requestBatch,
  };

  Logger.info(
    ['POST: Device Search Requested', deviceState, body],
    LogArea.Api
  );
  return MyKeysApi.post('devices/Search', body, true)
    .then((res) => MyKeysApi.Map.mapDeviceListDto(res.data))
    .catch(MyKeysApi.parseError);
};

export const deactivate = (devices: Devices.PKey[]): Promise<any> => {
  const body = {
    devices,
  };
  Logger.info(['POST: Device Deactivate Requested', body], LogArea.Api);
  return MyKeysApi.post('devices/Deactivate', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};

export const activate = (devices: Devices.PKey[]): Promise<any> => {
  const body = {
    devices,
  };
  Logger.info(['POST: Device Activate Requested', body], LogArea.Api);
  return MyKeysApi.post('devices/Activate', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};

export const setReadRights = (
  devices: Devices.PKey[],
  deviceLabels: string[],
  criteria: CriteriaListDto,
  customer: CustomerInfo
): MyKeysPromise<boolean> => {
  const body: SetReadRightsRequest = {
    criteria,
    devices,
    deviceLabels,
    assigneeCustomerId: customer.customerId,
    assigneeCustomerName: customer.customerName,
  };
  Logger.info(
    ['POST: Device setReadRights Requested', body],
    LogArea.Api
  );
  return MyKeysApi.post('devices/SetReadRights', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};

export const assingReadRights = (
  devices: Devices.PKey[],
  labels: string[],
  customer: CustomerInfo
): MyKeysPromise<boolean> => {
  const criteria = Devices.getCriteria();
  const d = devices?.length ? devices : getDevicesSNFilter();
  const l = labels?.length ? labels : getDevicesLabelsFilter();
  Logger.info(
    ['POST: Device assingReadRights Requested', criteria, d, l],
    LogArea.Api
  );
  return setReadRights(d, l, criteria, customer);
};

export const resetReadRights = (
  devices: Devices.PKey[],
  deviceLabels: string[],
  criteria: CriteriaListDto
): MyKeysPromise<boolean> => {  
  const body: SetReadRightsRequest = { criteria, devices, deviceLabels };
  Logger.info(
    ['POST: Device resetReadRights Requested', body],
    LogArea.Api
  );
  return MyKeysApi.post('devices/RemoveReadRights', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};

export const removeReadRights = (
  devices: Devices.PKey[],
  labels: string[],
): MyKeysPromise<boolean> => {
  const criteria = Devices.getCriteria();
  const d = devices?.length ? devices : getDevicesSNFilter();
  const l = labels?.length ? labels : getDevicesLabelsFilter();
  Logger.info(
    ['POST: Device removeReadRights Requested', criteria, d],
    LogArea.Api
  );
  return resetReadRights(d, l, criteria);
};

const pageReqEmpty: PageRequest = { pageIndex: 0, pageSize: -1 };
const pageReqDefault: PageRequest = {
  pageIndex: 0,
  pageSize: PageSize,
};
const datesReqDefault: DatesRequest = {};
export const getDeviceInfoBase = (
  device: Devices.PKey,
  pageReq = pageReqEmpty,
  datesReq = datesReqDefault
): MyKeysPromise<Devices.DeviceExtendedWithHistoricalData> => {
  const body: DeviceInfoRequest = {
    manufactureId: device.manufactureId,
    serialNumber: device.serialNumber,
    ...pageReq,
    ...datesReq,
  };
  Logger.info(['POST: Device Info Requested', body], LogArea.Api);
  return MyKeysApi.post('devices/GetLogInfo', body, true)
    .then((res) => MyKeysApi.Map.mapDeviceInfoDto(res.data))
    .catch(MyKeysApi.parseError);
};

export const getDeviceInfo = (device: Devices.PKey) =>
  getDeviceInfoBase(device);

export const getDeviceLogs = (
  device: Devices.PKey,
  from?: string,
  to?: string
): MyKeysPromise<Devices.DeviceExtendedWithHistoricalData> => {
  const dateReq: DatesRequest = { from, to };
  return getDeviceInfoBase(device, pageReqDefault, dateReq);
};
